<template>
    <div>
        <div
                v-if="selectedOption === null"
                class="form-group">
            <div class="col-xs-6 btn-group-spaced">
                <button
                        v-on:click="selectedOption = 'self'"
                        class="btn btn-primary">
                    {{ 'Set an appointment myself' | trans }}
                </button>
            </div>
            <div class="col-xs-6 btn-group-spaced" v-if="job.workerIntervention.isWorkerOwner === false">
                <button
                        v-on:click="selectedOption = 'office'"
                        class="btn btn-primary">
                    <nl2br tag="span" v-bind:text="'Ask the office\nto set an appointment' | trans"/>
                </button>
            </div>
        </div>

        <CreateContinuationJob
                v-if="selectedOption === 'self'"
                v-bind:originalJob="job">
        </CreateContinuationJob>

        <AskOfficeForNewAppointment
                v-if="selectedOption === 'office'"
                v-on:comment:validate="validateCommentToOfficeForNewAppointment($event)">
        </AskOfficeForNewAppointment>
    </div>
</template>

<script>
    import CreateContinuationJob from './CreateContinuationJob';
    import AskOfficeForNewAppointment from './AskOfficeForNewAppointment';

    export default {
        props: {
            job: Object
        },
        data() {
            return {
                selectedOption: null
            };
        },
        methods: {
            validateCommentToOfficeForNewAppointment(comment) {
                this.job.workerIntervention.schedule.comment = comment;
                this.$emit('validateCommentToOfficeForNewAppointment');
            }
        },
        components: {CreateContinuationJob, AskOfficeForNewAppointment}
    }
</script>

<style scoped>
    .btn-group-spaced{
        padding:3px !important;
        margin:0px !important;
    }
</style>
